<template>
  <v-container id="inventory-edit" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              {{
                id ? $i18n.t("Edit Inventory ") : $i18n.t("Create Inventory")
              }}
            </div>
          </template>

          <v-form id="form">
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" md="3">
                  <z-client-select
                    class="purple-input"
                    v-model="inventory.client_id"
                    withSelf
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <z-entity-select
                    class="purple-input"
                    v-model="inventory.clientEntity_id"
                    :corp="inventory.client_id"
                    :label="$i18n.t('Client Entity')"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <z-vendor-select
                    class="purple-input"
                    v-model="inventory.vendor_id"
                    withSelf
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <z-entity-select
                    class="purple-input"
                    v-model="inventory.vendorEntity_id"
                    :corp="inventory.vendor_id"
                    :label="$i18n.t('Vendor Entity')"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <z-vehicle-type-select
                    class="purple-input"
                    v-model="inventory.vehicleType"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="inventory.available"
                    :label="$i18n.t('Available')"
                    type="number"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="inventory.maxAvailable"
                    :label="$i18n.t('Max Available')"
                    type="number"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="text-right">
                  <v-btn
                    color="success"
                    class="mr-0"
                    @click="save()"
                    :loading="loading"
                  >
                    <h3>{{ $i18n.t("Save") }}</h3>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  inventory = {};
  id = null;

  get loading() {
    return common.loading;
  }

  async save() {
    try {
      common.setLoading(true);
      const response = await doPost("/api/inventory/save", this.inventory);
      if (!this.id) this.$router.push("/settings/inventory/" + response._id);
      this.get(response._id);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      const response = await doGet("/api/inventory/" + id + "/detail");
      this.inventory = response;
      this.id = this.inventory._id;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
  }

  newItem(itemList) {
    if (!itemList) itemList = [];
    itemList.push({});
    return itemList;
  }

  remove(list, _index) {
    list.splice(_index, 1);
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
</style>
